import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "store";
// material-ui
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";

// project imports
import Header from "./Header";
import Sidebar from "./Sidebar";
import MainContentStyled from "./MainContentStyled";
import Loader from "shared/ui/Loader";
import Breadcrumbs from "shared/ui/extended/Breadcrumbs";
import useGetBreadcrumbs from "shared/hooks/useGetBreadCrumbs";
import {
  handlerDrawerOpen,
  useGetMenuMaster,
} from "shared/hooks/useGetMenuMaster";

// types
import { MenuOrientation } from "shared/types/config";


const MainLayout = () => {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down("md"));
  const { borderRadius, container, miniDrawer, menuOrientation } = useSelector(
    (state) => state.config,
  );
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const currentBreadcrumb = useGetBreadcrumbs();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  useEffect(() => {
    handlerDrawerOpen(!miniDrawer);
  }, [miniDrawer]);

  useEffect(() => {
    downMD && handlerDrawerOpen(false);
  }, [downMD]);

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  if (menuMasterLoading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Plate</title>
        <meta name='title' />
      </Helmet>
      <Box sx={{ display: "flex" }}>
        {/* header */}
        <AppBar
          enableColorOnDark
          position='fixed'
          color='inherit'
          elevation={0}
          sx={{ bgcolor: "background.default" }}
        >
          <Toolbar sx={{ p: isHorizontal ? 1.25 : 2 }}>
            <Header />
          </Toolbar>
        </AppBar>

        {/* menu / drawer */}
        <Sidebar />

        {/* main content */}
        <MainContentStyled
          {...{ borderRadius, menuOrientation, open: drawerOpen, theme }}
        >
          <Container
            maxWidth={container ? "lg" : false}
            {...(!container && {
              sx: {
                px: { xs: 0 },
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              },
            })}
          >
            {/* breadcrumb */}
            <Breadcrumbs
              custom
              heading={currentBreadcrumb.breadcrumbHeading}
              links={currentBreadcrumb.breadcrumbLinks}
            />
            <Outlet />
          </Container>
        </MainContentStyled>
      </Box>
    </>
  );
};

export default MainLayout;
